var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('h4',{staticClass:"success-text"},[_vm._v("成功授权第三方小程序开发权限")])])
}]

export { render, staticRenderFns }